import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import { AjaxContext, AppContext } from 'commons-ui';
import { PAGE_NAMES, USER_PROFILE_RESOURCES } from 'constant';

const useService = () => {
	const {
		app: { appName }
	} = useContext(AppContext);
	const { postData } = useContext(AjaxContext);
	const getUserData = useCallback(async (selectionType: string, selectedValue: string | number) => {
		const result = await postData({
			endpoint: `/dashboard/getBasicUserDetails/${PAGE_NAMES.userProfile}-${USER_PROFILE_RESOURCES.basicDetails}-getBasicUserDetails`,
			queryParams: {
				appName
			},
			body: {
				[selectionType || '']: selectedValue
			}
		});
		const data = _get(result, ['data', 'data'], {});
		return data;
	}, []);

	return { getUserData };
};

export default useService;
